<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center p-4">
    <div class="max-w-md w-full">
      <div class="bg-white rounded-lg shadow-lg p-8">
        <div class="text-center mb-8">
          <div class="flex justify-center mb-4">
            <img 
              src="@/assets/Logo.png" 
              alt="کبابی مارو" 
              class="navbar-logo w-20 h-20"
            />
          </div>
          <h2 class="text-2xl font-semibold text-gray-800">ورود به پنل مدیریت</h2>
          <p class="text-gray-600 mt-2">کبابی مارو</p>
        </div>

        <form @submit.prevent="handleLogin" class="space-y-6">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">نام کاربری</label>
            <input 
              v-model="username"
              type="text"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brown-500 focus:border-transparent"
              placeholder="نام کاربری خود را وارد کنید"
              required
            />
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">رمز عبور</label>
            <input 
              v-model="password"
              type="password"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brown-500 focus:border-transparent"
              placeholder="رمز عبور خود را وارد کنید"
              required
            />
          </div>

          <div v-if="error" class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg">
            {{ error }}
          </div>

          <button 
            type="submit"
            :disabled="loading"
            class="w-full bg-brown-600 text-white py-3 rounded-lg font-medium hover:bg-brown-700 transition-colors disabled:opacity-50"
          >
            {{ loading ? 'در حال ورود...' : 'ورود' }}
          </button>
        </form>

        <div class="mt-6 text-center">
          <router-link 
            to="/"
            class="text-brown-600 hover:text-brown-800 font-medium"
          >بازگشت به منو</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { authAPI } from '@/services/api'

export default {
  name: 'AdminLogin',
  emits: ['login-success'],
  setup() {
    const username = ref('')
    const password = ref('')
    const loading = ref(false)
    const error = ref('')

    const handleLogin = async () => {
      loading.value = true
      error.value = ''

      try {
        const response = await authAPI.login({
          username: username.value,
          password: password.value
        })

        localStorage.setItem('authToken', response.data.token)
        window.location.href = '/admin'
      } catch (err) {
        console.error('Login error:', err)
        error.value = 'نام کاربری یا رمز عبور اشتباه است'
      } finally {
        loading.value = false
      }
    }

    return {
      username,
      password,
      loading,
      error,
      handleLogin
    }
  }
}
</script> 